import { FormErrorMessage as ChakraFormErrorMessage } from '@chakra-ui/react';

export const FormErrorMessage = ChakraFormErrorMessage;
